import { UiSettings } from './ui-settings';
import * as moment from 'moment';


export const ZHelpers = {
    Common: {
        printPage: (pageUrl, silent = false) => {
            ///"/print/" proxy page used as a workaround for CORS.
            // No onload event will fire if printable page is on other domain.
            const url = UiSettings.environment.apiUrl + '/print?url=' + encodeURIComponent(pageUrl);
            if (silent) {
                const oHiddFrame = document.createElement('iframe');
                oHiddFrame.onload = function () {
                    this.contentWindow.onbeforeunload = function () {
                        document.body.removeChild(this['__container__']);
                    };
                };
                oHiddFrame.style.visibility = 'hidden';
                oHiddFrame.style.position = 'fixed';
                oHiddFrame.style.right = '0';
                oHiddFrame.style.bottom = '0';
                oHiddFrame.src = url;
                document.body.appendChild(oHiddFrame);
            } else {
                const w = window.open(url);
            }
        }
    },
    OrderPallets: {
        foramtPalletId(id: number) {
            const size = 8;
            const s = '000000000000' + id;
            return s.substr(s.length - size);
        }
    },
    SmartTable: {
        dateTimeFormatter: (cell, row) => moment(cell).format(UiSettings.dateTimeFormat),
        dateFormatter: (cell, row) => moment(cell).format(UiSettings.dateFormat),
        timeFormatter: (cell, row) => moment(cell).format(UiSettings.timeFormat),

        // This is some really bad example of good workaround, or how NG components should not be made.
        // Idea is to set loading indication status somehow (via vanilla JS DOM!?).
        // Initial message is stored in UiSettings.defaultSmartTableSettings.noDataMessage
        setData: (source, data) => {
            if (!data || data.length === 0) {
                const selector = 'tbody[ng2-st-tbody] > tr:first-child > td:first-child';
                [].slice.call(window.document.querySelectorAll(selector))
                    .map((item => {
                        if (item.innerHTML === UiSettings.defaultSmartTableSettings.noDataMessage) {
                            item.innerHTML = UiSettings.defaultSmartTableSettings.noDataMessageRealOne;
                        }
                    }));
                source.load([]);
                source.empty();
            } else {
                source.load(data);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/zhelpers.ts